import { Descriptions } from 'antd'
import { useDetailData } from './DetailDataProvider'
import { getAttributeKeyLabel } from 'Services/WeaverUtils'

export default NodeDetails = (props) ->

  [{ node, isLoading }, dispatch] = useDetailData()

  <Descriptions
    title={node.className}
    size="small"
    bordered={true}
    column={1}
    className="attributes-container"
  >
    {_.map(node.attributes(), (val, key) ->
      <Descriptions.Item label={_.startCase(getAttributeKeyLabel(key))} key={key}>
        { val }
      </Descriptions.Item>
    )}
  </Descriptions>